<template>
  <div style="margin-top: -100px;">
    <div class="contactus-1 section-image" style=" background-image: url('/img/backgrounds/3D_1.png')">
      <div class="container">
        <div class="row header-margin" >
          <div class="col-md-6" style="margin-top: -100px" >
            <h2 class="title">Explore the OTC Platform firsthand</h2>
            <h4 class="description">
              Curious to see how it works? We'd be happy to show you around.
              We offer live demos of Off The Couch at a time that works for you. It's a chance to see if our software might be a good fit for your escape room business.
            </h4>
            <h4 class="description">
              Looking forward to connecting with you!
            </h4>
            <h4 class="description">
              Ready to learn more? Get in touch:
            </h4>
            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="tim-icons icon-notes"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Fill out the form to the right
                </h4>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <i class="tim-icons icon-email-85"></i>
              </div>
              <div class="description">
                <h4 class="info-title">Send us an email at
                  <a href="mailto:contact@offthecouch.io">contact@offthecouch.io</a>
                </h4>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-discord" viewBox="0 0 16 16">
                  <path d="M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612"/>
                </svg>
              </div>
              <div class="description">
                <h4 class="info-title">Join the community
                  <a href="https://discord.gg/752E9HM6tt" target="_blank">Discord</a>
                </h4>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-12 ml-auto mr-auto" >
            <div class="card card-contact card-raised demo-container">
              <form role="form" id="contact-form" method="post">
                <div class="card-header text-center">
                  <h4 class="card-title">Your information</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <base-input v-model="user.first_name" label="First name" placeholder="First name"></base-input>
                    </div>
                    <div class="col-md-6 pl-2">
                      <div class="form-group">
                        <base-input v-model="user.last_name" label="Last name" placeholder="Last name"></base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input v-model="user.email" label="Email" placeholder="Email"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input v-model="user.phone" label="Phone" placeholder="Phone"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input v-model="user.company_name" label="Company name" placeholder="Company name"></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-right" >
                      <base-button type="primary" v-on:click="submitDemoRequestForm()">Submit</base-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";

export default {
  name: "GetDemo",
  data() {
    return {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        company_name: '',
        phone: ''
      }
    };
  },
  methods: {
    async submitDemoRequestForm(){
      let url = 'https://api.offthecouch.io/demo-request'

      let data = {
        user: this.user,
      }
      axios.post(url, data)
        .then(response => {
          swal('Success!', 'We will reach out to you soon', 'success')
          this.user = {
            first_name: '',
            last_name: '',
            email: '',
            company_name: '',
            phone: ''
          }
        })
        .catch(err => {
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
  }
}
</script>

<style scoped>
@media (min-width: 1024px) {
  .demo-container{
    margin-top: -100px;
  }
  .header-margin {
    margin-top: 300px;
  }

}

@media (max-width: 768px) {
  .header-margin {
    margin-top: 150px;
  }
}

</style>
